import type { SVGProps } from 'react';
import * as React from 'react';

const IssueTrackerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="product-logo/issue-tracker">
      <path
        id="Vector"
        d="M2.1077 22.0151H21.8923C22.7185 22.0151 23.2496 21.1447 22.8808 20.4144L14.3827 3.47721C13.3942 1.5076 10.6205 1.5076 9.63204 3.47721L7.77309 7.17299C7.52228 7.67461 7.68457 8.27951 8.1493 8.58934L16.4408 14.0924C16.9425 14.4244 17.09 15.1104 16.758 15.6194L15.1425 18.1054C14.8106 18.6218 14.1171 18.762 13.6008 18.4226L6.03216 13.399C5.4789 13.0302 4.72646 13.2293 4.43139 13.8269L1.1192 20.4144C0.750364 21.152 1.28149 22.0151 2.1077 22.0151Z"
        fill="#FE830C"
      />
      <path
        id="Intersect"
        d="M9.63184 3.4768C10.6204 1.50756 13.3942 1.50758 14.3828 3.4768L21.418 17.4993C21.3337 17.3818 21.2315 17.2793 21.1104 17.1985L16.5303 14.1584C16.5018 14.1352 16.4716 14.1127 16.4404 14.092L8.14942 8.58911C7.68471 8.27927 7.52264 7.6747 7.77344 7.17309L9.63184 3.4768Z"
        fill="#FEA011"
      />
      <g id="Intersect_2">
        <path
          d="M4.43172 13.8267C4.72686 13.2294 5.47911 13.0302 6.0323 13.399L13.6007 18.4225C14.082 18.7388 14.7166 18.638 15.0694 18.2047L12.9444 21.4693C12.7231 21.8087 12.3462 22.0152 11.9405 22.0152H2.1075C1.28149 22.0151 0.750622 21.1522 1.11922 20.4146L4.43172 13.8267Z"
          fill="#FE6407"
        />
        <path
          d="M16.9503 15.317L16.796 15.5523C16.8403 15.4727 16.8737 15.3901 16.8966 15.3053L16.9503 15.317Z"
          fill="#FE6407"
        />
      </g>
    </g>
  </svg>
);
export default IssueTrackerIcon;
